import { useCallback } from 'react';
import { succDuration, errDuration } from '../../constants';
import toast from 'react-hot-toast';

export const showLoadToaster = (msg) => {
  //   toast.dismiss();
  const toastId = toast.loading(msg);
  return toastId;
};

export const showSuccToaster = (msg, toastId) => {
  toast.success(msg, { id: toastId || null, duration: succDuration });
};

export const showErrToaster = (msg, toastId) => {
  toast.error(msg, { id: toastId || null, duration: errDuration });
};
